import React from "react";
import "./style.scss";
import SpecialOfferClock from "../../../../assets/SpecialOfferClock.svg";
import Arrow from "../../../../assets/SpecialOfferArrow.svg";
import { useTranslation } from "react-i18next";
import useCountdown from "../../../../hooks/useCountdown";
import { GetCurrByCode } from "helpers/currencies";

interface SpecialOfferCardProps {
  price: number;
  symbol: string;
  currency: {
    from: string;
    to: string;
    symbol: string;
  };
  valid: {
    from: Date;
    to: Date;
  };
  volume: {
    from: number;
    to: number;
  };
  selected?: boolean;
  onClick: () => void;
}

const SpecialOfferCard: React.FC<SpecialOfferCardProps> = ({
  price,
  symbol,
  currency,
  valid,
  volume,
  selected,
  onClick,
}) => {
  const { t } = useTranslation("app");
  const countdown = useCountdown({ validFrom: valid.from, validTo: valid.to });

  return (
    <div
      className={`special-offer-card ${
        selected && " special-offer-card-selected"
      }`}
      onClick={onClick}
    >
      <div className="special-offer-card-header">
        <p>{t("specialOffer")}</p>
        <input
          type="radio"
          className="special-offer-radio-input"
          checked={selected}
          onChange={onClick}
          tabIndex={-1}
        />
      </div>
      <div className="special-offer-card-main">
        <div className="special-offer-card-main-header">
          <span>
            {currency.from}
            <img src={Arrow} alt="Arrow" />
            {currency.to}
          </span>
          <p>
            <img src={SpecialOfferClock} alt="Clock" />
            {countdown}
          </p>
        </div>
        <p className="special-offer-card-main-price">
          {+price.toFixed(4)}
          {GetCurrByCode(symbol)?.symbol || symbol}
        </p>
        <p className="special-offer-card-main-volume">
          {t("Volume")}: {+volume.from.toFixed(2)} - {+volume.to.toFixed(2)}{" "}
          {currency.symbol}
        </p>
      </div>
    </div>
  );
};

export default SpecialOfferCard;
